export default __webpack_public_path__ + "static/media/youthMusicProject.c1050ffd.png";